import { render } from "./azure.vue?vue&type=template&id=efcb594c&scoped=true"
import script from "./azure.vue?vue&type=script&lang=js"
export * from "./azure.vue?vue&type=script&lang=js"

import "./azure.vue?vue&type=style&index=0&id=efcb594c&scoped=true&lang=css"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efcb594c"]])

export default __exports__